import { ApplyApi, IApplicationData, IApplicationInformation, ISaveApplicationResponse } from '@apply/api/src/api/ApplyApi';
import { useAuthentication } from '../../Login/hooks/useAuthentication';
import { useQueryClient } from '@tanstack/react-query';
import { applicationQueryKey } from '../../queries/applicationQueries';
import { useParams } from 'react-router-dom';
import { applicationInsights } from '../../ApplicationInsights';
import { useWaitOverlayStore } from '@apply/components';

export const useSaveApplicationWithoutValidation = () => {
    const applyApi = new ApplyApi(applicationInsights);
    const { authentication } = useAuthentication();
    const queryClient = useQueryClient();
    const { entryGuid } = useParams<{ entryGuid?: string }>();

    const saveApplicationNoValidation = async (complete = false): Promise<ISaveApplicationResponse | false> => {
        if (!authentication) throw new Error('A valid logged in user is required');

        const { setWaiting } = useWaitOverlayStore.getState();
        setWaiting(true, 'Saving your changes...');

        try {
            const cached = queryClient.getQueryData<IApplicationData>(applicationQueryKey(entryGuid ?? ''));

            const data: IApplicationData = {
                entryGuid: entryGuid ?? '',
                email: authentication.user.email,
                information: JSON.stringify(cached?.information) as unknown as IApplicationInformation,
                complete: complete,
                pausePoint: cached?.information?.pausePoint ?? null,
            };

            const response = await applyApi.saveApplication(data);

            if (response.statusCode !== 200) throw new Error('Save Application failed');

            return response.result;
        } finally {
            setWaiting(false);
        }
    };

    return { saveApplicationNoValidation };
};
